import axios from '@/api/api-request'

const projectUrl = '/testEntrust'

// 管理-保存委托单填写信息(上一步)
export const SaveTestEntrustOfMemberBack = (data) => {
  return axios.request({
    url: projectUrl + '/SaveTestEntrustOfMemberBack.do',
    method: 'post',
    data: data
  })
}
// 委托管理-查看进度
export const checkProgress = (data) => {
  return axios.request({
    url: projectUrl + '/checkProgress.do',
    method: 'post',
    data: data
  })
}
// 委托管理-查询所有检验产品标准项目
export const getAllProductStandardItems = (data) => {
  return axios.request({
    url: projectUrl + '/getAllProductStandardItems.do',
    method: 'post',
    data: data
  })
}
// 委托管理-获取委托单填写数据
export const getTestEntrustResponse = (params) => {
  return axios.request({
    url: projectUrl + '/getTestEntrustResponse.do',
    method: 'post',
    params: params
  })
}

// 委托管理-查询当前委托单位的所有生产商
export const getCompanyAllManufacturers = (data) => {
  return axios.request({
    url: projectUrl + '/getCompanyAllManufacturers.do',
    method: 'post',
    data: data
  })
}
// 委托管理-查询委托单位信息
export const getEntrustCompany = (data) => {
  return axios.request({
    url: projectUrl + '/getEntrustCompany.do',
    method: 'post',
    data: data
  })
}
// 委托管理-查看委托书
export const getEntrustFile = (data) => {
  return axios.request({
    url: projectUrl + '/getEntrustFile.do',
    method: 'post',
    data: data
  })
}
// 委托管理-获取产品分类树形列表
export const getProductTypeTree = (data) => {
  return axios.request({
    url: projectUrl + '/getProductTypeTree.do',
    method: 'post',
    data: data
  })
}
// 委托管理-查询委托单信息
export const getTestEntrustById = (params) => {
  return axios.request({
    url: projectUrl + '/getTestEntrustById.do',
    method: 'post',
    params: params
  })
}

// 管理-提交检验委托单
export const submitTestEntrustForm = (data) => {
  return axios.request({
    url: projectUrl + '/submitTestEntrustForm.do',
    method: 'post',
    data: data
  })
}
// 管理-查询委托单填写第一个页面数据
export const getTestEntrustFirstPage = (data) => {
  return axios.request({
    url: projectUrl + '/getTestEntrustFirstPage.do',
    method: 'post',
    data: data
  })
}
// 管理-查询委托单填写第二个页面数据
export const getTestEntrustSecondPage = (data) => {
  return axios.request({
    url: projectUrl + '/getTestEntrustSecondPage.do',
    method: 'post',
    data: data
  })
}
// 管理-查询委托单填写第三个页面数据
export const getTestEntrustThirdPage = (data) => {
  return axios.request({
    url: projectUrl + '/getTestEntrustThirdPage.do',
    method: 'post',
    data: data
  })
}
// 管理-查询该用户企业下的发票抬头列表
export const getWebInvoiceByCompany = (data) => {
  return axios.request({
    url: projectUrl + '/getWebInvoiceByCompany.do',
    method: 'post',
    data: data
  })
}
// 管理-我的委托
export const list = (data) => {
  return axios.request({
    url: projectUrl + '/list.do',
    method: 'post',
    data: data
  })
}

// 管理-保存委托单填写（第一个）页面
export const saveTestEntrustFirstPage = (data) => {
  return axios.request({
    url: projectUrl + '/saveTestEntrustFirstPage.do',
    method: 'post',
    data: data
  })
}
// 填写委托单（会员）-提交检验委托书
export const saveEntrustForm = (data) => {
  return axios.request({
    url: projectUrl + '/saveEntrustForm.do',
    method: 'post',
    data: data
  })
}
// 管理-委托单填写返回上一页（第三页返回第二页）
export const saveTestEntrustBackSecond = (data) => {
  return axios.request({
    url: projectUrl + '/saveTestEntrustBackSecond.do',
    method: 'post',
    data: data
  })
}
// 管理-保存委托单填写信息(下一步)
export const saveTestEntrustOfMemberNext = (data) => {
  return axios.request({
    url: projectUrl + '/saveTestEntrustOfMemberNext.do',
    method: 'post',
    data: data
  })
}
// 管理-管理-委托单填写确定支付
export const saveTestEntrustPayment = (data) => {
  return axios.request({
    url: projectUrl + '/saveTestEntrustPayment.do',
    method: 'post',
    data: data
  })
}
// 管理-保存选中的发票抬头到委托表
export const saveWebInvoiceCheck = (data) => {
  return axios.request({
    url: projectUrl + '/saveWebInvoiceCheck.do',
    method: 'post',
    data: data
  })
}
// 管理-保存选中的地址
export const saveWebShippingAddressCheck = (data) => {
  return axios.request({
    url: projectUrl + '/saveWebShippingAddressCheck.do',
    method: 'post',
    data: data
  })
}
// 委托管理-发送样品
export const sendSample = (data) => {
  return axios.request({
    url: projectUrl + '/sendSample.do',
    method: 'post',
    data: data
  })
}
// 委托管理-保存转账凭证信息
export const saveTransferVoucher = (params) => {
  return axios.request({
    url: projectUrl + '/saveTransferVoucher.do',
    method: 'post',
    params: params
  })
}

// 委托管理-会员删除委托单
export const delEntrust = (data) => {
  return axios.request({
    url: projectUrl + '/delEntrust.do',
    method: 'post',
    data: data
  })
}

// 获取快递信息
export const getExpressList = (data) => {
  return axios.request({
    url: projectUrl + '/getExpressList.do',
    method: 'post',
    data: data
  })
}

// 刷新支付二维码
export const refreshQrCode = (params) => {
  return axios.request({
    url: projectUrl + '/refreshQrCode.do',
    method: 'post',
    params: params
  })
}

// 下载委托书
export const downEntrustFile = (entrustId) => {
  return axios.request({
    url: projectUrl + '/downEntrustFile.do?entrustId=' + entrustId,
    method: 'post',
    responseType: 'arraybuffer'
  })
}

// 获取委托统计
export const getEntrustCount = (params) => {
  return axios.request({
    url: projectUrl + '/getEntrustCount.do',
    method: 'post',
    data: params
  })
}
